// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { AlertsTestingAreaId } from './AlertsTestingAreaId'
import {
  AlertsTestingAreaNavigation,
  AlertsTestingAreaNavigationIcon,
} from './AlertsTestingAreaNavigation'
import { AlertsTestingAreaRoutes } from './AlertsTestingAreaRoutes'

const LazyAlertsTestingComponent = lazy(() => import('./AlertsTestingArea'))

const AlertsTestingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyAlertsTestingComponent />
  </SuspenseLoadingWrapper>
)

export const AlertsTestingArea = {
  id: AlertsTestingAreaId,
  requiredRight: BoumRight.AREA_TEST,
  Icon: AlertsTestingAreaNavigationIcon,
  NavigationComponent: AlertsTestingAreaNavigation,
  route: {
    path: AlertsTestingAreaRoutes.route,
    component: AlertsTestingComponent,
  },
}
